import React from "react";
import {useDispatch, useSelector} from "react-redux";
import DataListBodyRow from "../../../../../../../../components/data-list/data-list-body/data-list-body-row";
import Avatar from "../../../../../../../../components/avatar";
import {API_ROOT} from "../../../../../../../../utils";
import Select from "../../../../../../../../components/select";
import UserStatuses
    from "../../../../../../../sharing/components/sharing-details-popup/components/add-collaborators-popup/components/list-of-collaborators/components/list-of-collaborators-details/components/list-of-collaborators-details-content/components/collaborator-item/components/user-statuses";
import Sprite from "../../../../../../../../components/sprite/components/status";
import Button from "../../../../../../../../components/button";
import Icon from "../../../../../../../../components/icon";
import Labels from "./components/labels";
import {confirmFreeLicensesPopup} from "../../../../../../../../../actions/popupActions";
import {putUpdateRole} from "../../../../../../../../../actions/usersListActions";

function UserList ({ collaborator, newRole, onRoleChange, isUpdatingRole, onRoleUpdate }) {

    const profile = useSelector(state => state.profileReducer.getProfile);

    const dispatch = useDispatch();

    const handleFreeLicenses = (e) => {
        dispatch(confirmFreeLicensesPopup(e.currentTarget.dataset.collaboratorId))
    };

	const handleChangeRole = (e) => {
		onRoleChange(collaborator.id, e.currentTarget.value);
	};

    const handleClickUpdateRole = () => {
	    onRoleUpdate(collaborator.id, true);
        dispatch(putUpdateRole({
            userId: collaborator.id,
            role: newRole
        }))
    };

    return (
        <DataListBodyRow key={collaborator.id}>
            <div className="col-3 d-flex align-items-center">
                <Avatar size={36} className="mr-3 border-0" src={`${API_ROOT}/account/avatar/${collaborator.id}`} />
                <div className="text-truncate">
                    <div><strong>{collaborator.name}</strong></div>
                    <div>{collaborator.email}</div>
                </div>
            </div>
            <div className="col-1 text-center">
                <Select
                    disabled={collaborator.editable === false}
                    onChange={ handleChangeRole }
                    style={{
                        fontSize: "1em",
                        backgroundColor: newRole === 'ADMINISTRATOR'
                            ? '#efe3e9'
                            : newRole === 'BUYER'
                                ? '#f1e0ce'
                                : '#dbe4eb'
                    }}
                    value={newRole}
                    name={`user-role-${collaborator.id}`}
                    id={`user-role-${collaborator.id}`}
                >
                    <option value="ADMINISTRATOR">Admin</option>
                    <option value="USER">User</option>
                </Select>
            </div>
            <div className="col-2 text-center">
                <UserStatuses
                    collaboratorId={collaborator.id}
                    collaboratorEmail={collaborator.email}
                    collaboratorType={collaborator.type}
                    collaboratorStatuses={collaborator.statuses}
                />
            </div>
            <div className="col-1 text-center">
                <Sprite status={collaborator.statuses.licenseLimitReached || collaborator.statuses.unusedLicense ? 'NOT_LICENSED' : 'LICENSED'} width={20} height={20} />
            </div>
            <div className="col-1 text-center">
                {
                    collaborator.id !== profile.id && profile.role === "ADMINISTRATOR"
                        ?
                        <Button
                            data-collaborator-id={collaborator.id}
                            onClick={handleFreeLicenses}
                            className={'btn-link free-licenses'}
                        >
                            <Icon name="user-times"/>
                        </Button>
                        :
                        null
                }
            </div>
            <div className="col-2">
                <Labels collaborator={collaborator}/>
            </div>
            <div className="col-2 text-center">
                {
                    collaborator.role !== newRole
                    ?
                        isUpdatingRole
                        ?
                            <Button className="btn-link text-nowrap font-weight-normal" disabled={true}>
                                <Icon animated={'pulse'} name="spinner"/>
                            </Button>
                        :
	                        <Button className="btn-link text-nowrap font-weight-normal" onClick={ handleClickUpdateRole }>
		                        Save changes
	                        </Button>
                    :
                        ''
                }
            </div>
        </DataListBodyRow>
    )
}

export default UserList
